import { _uploadAppStatics } from '@/utils'
import { getList } from '@/apis'

export default {
  data () {
    return {
      user: null,
      section1: [],
      section2: [],
      section3: [],
      section4: [],
      list: []
    }
  },
  mounted () {
    getList().then(res => {
      const { list = [] } = res.data.data
      const [section1, section2, section3, section4] = list.map(item => item.items)

      this.section1 = section1.slice(0, 3)
      this.section2 = section2.slice(0, 3)
      this.section3 = section3.slice(0, 2)
      this.section4 = section4.slice(0, 3)

      this.list = [...section1, ...section2, ...section3, ...section4]
    })


    this.$bus.$on('userChange', user => {
      this.user = user
    })

    if (this.jsBridge.isApp) {
      this.jsBridge.dispatch('getAppName')
      window.getAppNameCallback = (res) => {
        let data = {}
        if (typeof res === 'string') {
          data = JSON.parse(res)
        } else {
          data = res
        }
        this.appType = data.name
      }
    }
  },
  methods: {
    goDetail (data) {
      const { id, contentType, url } = data
      window._news = {
        type: contentType
      }
      const exOptions = {
        id
      }
      window._uploadAppStatics = _uploadAppStatics(3, '2021年5月榜单内容', 'click', exOptions)

      if (this.jsBridge.isApp) {
        if (this.appType === 'jin10App') {
          if (contentType === 'video') {
            this.jsBridge.dispatch('openAppVideoPlayer', { id, play_type: 0 })
          } else {
            this.jsBridge.dispatch('openAppRefer', { id, type: contentType })
          }
        } else {
          this.jsBridge.dispatch('openUrl', url)
        }
      } else {
        window.open(url)
      }
    }
  }
}
